export const en = {
  title: 'Taliban restrictions on women',
  intro: `In the beginning, Albanu promised to respect women's rights within the framework of the Sharia, but after coming to power, he issued decrees that continuously restricted women's education, work, social and political activities, and travel. Imposed restrictions. See some examples of these restrictions here.`,
  timeline: {
    title: 'Timeline of Events',
    hint: 'Click on any image to view a full-size version',
  },
  footer: {
    followUs: 'Follow us:',
    copyright: '',
    aboutTitle: 'About the project',
    about: [''],
    social: {
      instagram: '',
      youtube: '',
      x: '',
      facebook: '',
    },
  },
}
